<template>
    <div class="w-full md:w-1/2 lg:w-1/3 flex flex-initial cursor-pointer container"
        @click="handleAddressSelection">
        <div class="border border-black bg-white m-2 py-3 px-5 flex-initial w-full font-thin text-left">
            <div v-text="fullName" class="font-bold"></div>
            <div v-text="address.address1"></div>
            <div v-if="address.address2 && address.address2.length" v-text="address.address2"></div>
            <div v-text="address.postcode"></div>
            <div @click.stop><button class="order-summary__detail text-left mt-1 underline block" @click="toggleDeleteAddressModal" v-html="$t('REMOVE_ADDRESS')"></button></div>
        </div>
        <delete-addresses-modal
            v-if="showDeleteAddressModal"
            :isGifting="true"
            :address-id="address.id"
            @closed="toggleDeleteAddressModal"/>
    </div>
</template>

<script>
import DeleteAddressesModal from '@/components/modals/DeleteAddressesModal';

export default {
    name: 'GiftingAddressItem',
    data() {
        return {
            showDeleteAddressModal: false,
        };
    },
    props: {
        address: {
            required: true,
            type: Object,
        },
    },
    methods: {
        handleAddressSelection() {
            this.$store.commit('address/updateSelectedGiftingAddressId', this.address.id);
            this.$store.dispatch('gifting/fetchAvailableDeliveryDay');
            this.$emit('address-selected');
        },

        toggleDeleteAddressModal() {
            this.showDeleteAddressModal = !this.showDeleteAddressModal;
        },
    },
    computed: {
        fullName() {
            return `${this.address.first_name} ${this.address.last_name}`;
        },
    },

    components: {
        DeleteAddressesModal,
    },
};
</script>
<style scoped>
    .container {
        position: relative;
    }

    .cross-btn {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .cross {
        margin: 0;
        margin-top: .25rem;
    }
</style>
